import { z } from 'zod';
const decimal = z.string().regex(/^(?:0|[1-9]\d*)(?:\.\d{1,2})?$/);
const displayId = z.string().regex(/^[A-Z]{4}[23456789A-HJ-KM-NP-Z]{8}$/);
const loanPlanningRegisterRowSchema = z.object({
    loanDisplayId: displayId,
    lender: z.string(),
    amount: decimal,
    annualNominalRate: z.string(),
    startDate: z.iso.date(),
    endDate: z.iso.date().nullable(),
    finalPaymentDate: z.iso.date().nullable(),
    finalApprovedInterestDate: z.iso.date().nullable(),
    paymentPerMonth: decimal,
    fund: z.object({ fundDisplayId: displayId, name: z.string() }).nullable(),
    status: z.enum(['pending', 'approved']),
    selectedFiscalYearInterest: decimal,
    selectedFiscalYearPrincipal: decimal,
    remainingBalance: decimal,
    remainingPayments: z.number().int().nonnegative(),
});
export const budgetPlanningLoansInputSchema = z.object({
    fundDisplayId: displayId,
    fiscalYear: z.number().int().min(1900).max(2200),
    filters: z.object({ status: z.enum(['pending', 'approved']).optional() }).optional(),
});
export const budgetPlanningLoansOutputSchema = z.object({
    register: z.array(loanPlanningRegisterRowSchema),
    summary: z.object({
        loanCount: z.number().int().nonnegative(),
        remainingPayments: z.number().int().nonnegative(),
        selectedFiscalYearInterest: decimal,
        selectedFiscalYearPrincipal: decimal,
        projectedInterest: decimal,
        principalReferenceTotal: decimal,
        remainingBalanceTotal: decimal,
    }),
});
//# sourceMappingURL=budgetPlanningLoans.js.map